import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ExternalLink } from "lucide-react";

export const useJurisdictions = () =>
  useQuery({ queryKey: ["jurisdictions"], queryFn: () => api.get("/jurisdictions").then((r) => r.data), staleTime: Infinity });

// Researched license and tax rules for one jurisdiction, shown to owners before they submit.
export function Requirements({ j, testid = "jurisdiction-requirements" }) {
  if (!j) return null;
  return (
    <div className="rounded-2xl border border-teal-100 bg-teal-50/60 p-4 text-sm text-teal-950" data-testid={testid}>
      <p className="font-semibold">{j.name}: what you need</p>
      <ul className="mt-2 list-disc space-y-1 pl-5">
        {j.requirements.map((r) => <li key={r}>{r}</li>)}
        <li>Room tax: {j.rate}% ({j.tax_name}), filed with {j.tax_authority}. Only the first {j.taxed_nights_cap} nights of a stay are taxed.</li>
        {j.unverified && <li className="text-amber-800">Unverified: {j.unverified}</li>}
      </ul>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <a href={j.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 font-semibold text-primary hover:underline" data-testid={`${testid}-link`}>Official rules <ExternalLink className="h-3.5 w-3.5" /></a>
        <span className="text-xs text-amber-800">{j.note}</span>
      </div>
    </div>
  );
}
